// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const searchFormActions = require('client-v2/common/containers/search-form/actions')
const searchFormSelectors = require('client-v2/common/containers/search-form/selectors')
const articleActions = require('client-v2/common/models/article/actions')
const routerActions = require('client-v2/common/state/router/actions')

function mapStateToProps(state) {
  if (state.env.nativeEmbedded) {
    return { isVisible: false }
  }
  return {
    currentPath: state.router.location.pathname,
    isVisible: true,
    isSearchVisible: searchFormSelectors.isVisible(state),
    user: state.user.loggedIn ? state.user : null
  }
}

const mapDispatchToProps = {
  // Common actions
  onLinkClick: routerActions.navigate,
  onSearchClick: searchFormActions.show,
  onSearchDismiss: searchFormActions.reset,
  // Logged-in actions
  onAddClick: articleActions.showAddUrlModal,
  // Logged-out actions
  onLoginClick: authModalActions.showLogin,
  onSignupClick: authModalActions.showSignup
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      require('./component-dumb')
    )
  )
)
